import React from 'react'
import PropTypes from 'prop-types'
import Popup from './Popup'

class Confirm extends React.PureComponent {
  render() {
    return (
      <Popup
        header={this.props.header}
        body={
          <p>
            {this.props.body}
          </p>
        }
        footer={[
          {
            type: Popup.BUTTONTYPE.CLOSE,
            title: 'Annuler',
            color: 'red',
            icon: 'close',
            basic: true,
            onClick: () => { this.props.callback(false) }
          },
          {
            type: Popup.BUTTONTYPE.SUBMIT,
            title: this.props.confirmText,
            color: this.props.confirmColor,
            icon: this.props.confirmIcon,
            onClick: () => { this.props.callback(true) }
          }
        ]}
        size='mini'
        isSaving={this.props.isProceeding || false}
      />
    )
  }
}

Confirm.propTypes = {
  header: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  confirmText: PropTypes.string.isRequired,
  confirmColor: PropTypes.string,
  confirmIcon: PropTypes.string,
  isProceeding: PropTypes.bool,
  callback: PropTypes.func.isRequired
}

export default Confirm



// WEBPACK FOOTER //
// ./src/components/elements/Confirm.js